import * as types from '../constants/ActionTypes'

const browserNotifications = (state = {}, action) => {
  switch (action.type) {
    case types.MESSAGE_RECEIVED_SUCCESS:

      const message = action.payload.messages[Object.keys(action.payload.messages)[0]];

      const { chatId, content, id, senderId} = message;
      return {
        chatId,
        content,
        id,
        senderId
      };
    default:
      return state;
  }
};

export default browserNotifications;
